function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { createReducer } from "@reduxjs/toolkit";
import { memoize } from "proxy-memoize";
import { setUser } from "@sentry/react";
import posthog from "posthog-js";
import { callPrivateApiAction, callPublicApiAction } from "./api";
import handleReportError from "../features/errors/handleReportError";
import { configSelectors } from "./config";
import { myCompaniesActions, myCompaniesSelectors } from "./myCompanies";
import { Crisp } from "crisp-sdk-web";
import { setLocalStorageItem } from "../features/app/utils";
import { listFactoryActions } from "./listFactory";
import { handleWelcomeModalByFeatureFlag } from "../features/dashboard/utils";
import { USERS_ROLES } from "../features/users/utils";
/*******************
 * ACTION TYPES
 *******************/ var actionTypes = {
    STORE_AUTHENTICATION_TOKENS: "auth/STORE_AUTHENTICATION_TOKENS",
    STORE_IDENTITY: "auth/STORE_IDENTITY",
    CLEAR_IDENTITY: "auth/CLEAR_IDENTITY",
    SYNC_IDENTITY_WITH_API: "auth/SYNC_IDENTITY_WITH_API",
    UPDATE_EMAIL: "auth/UPDATE_EMAIL",
    SHOW_WELCOME_MODAL: "auth/SHOW_WELCOME_MODAL",
    STORE_PERMISSIONS: "auth/STORE_PERMISSIONS",
    STORE_SUBSCRIPTIONS: "auth/STORE_SUBSCRIPTIONS",
    STORE_PLANS: "auth/STORE_PLANS"
};
function getPermissionsForCompany(state, myCompanyId) {
    var _byCompany_find;
    if (!state.auth.permissions) {
        return [];
    }
    var _state_auth_permissions = state.auth.permissions, global = _state_auth_permissions.global, byCompany = _state_auth_permissions.byCompany;
    var selectedCompanyId = myCompanyId || myCompaniesSelectors.selectedCompanyId(state);
    var selectedCompanyPermissions = (_byCompany_find = byCompany.find(function(item) {
        return item.myCompanyId === selectedCompanyId;
    })) === null || _byCompany_find === void 0 ? void 0 : _byCompany_find.permissions;
    return selectedCompanyPermissions ? global.permissions.concat(selectedCompanyPermissions) : global.permissions;
}
function getAllSubscriptionsForCompany(param) {
    var state = param.state, myCompanyId = param.myCompanyId;
    var _state_auth_subscriptions;
    if (!state.auth.subscriptions) {
        return [];
    }
    if (myCompanyId) {
        var _state_auth_subscriptions1;
        return (_state_auth_subscriptions1 = state.auth.subscriptions) === null || _state_auth_subscriptions1 === void 0 ? void 0 : _state_auth_subscriptions1.filter(function(item) {
            var _item_myCompanyId;
            return ((_item_myCompanyId = item.myCompanyId) === null || _item_myCompanyId === void 0 ? void 0 : _item_myCompanyId.toString()) === (myCompanyId === null || myCompanyId === void 0 ? void 0 : myCompanyId.toString());
        });
    }
    var selectedCompanyId = myCompaniesSelectors.selectedCompanyId(state);
    return (_state_auth_subscriptions = state.auth.subscriptions) === null || _state_auth_subscriptions === void 0 ? void 0 : _state_auth_subscriptions.filter(function(item) {
        return item.myCompanyId.toString() === selectedCompanyId.toString();
    });
}
export var PLANS_MAP = {
    PLAN_ROBILL_BASIC_MONTHLY: "plan:robill-basic:monthly",
    PLAN_ROBILL_BASIC_QUARTERLY: "plan:robill-basic:quarterly",
    PLAN_ROBILL_BASIC_YEARLY: "plan:robill-basic:yearly",
    PLAN_ROBILL_SMART_MONTHLY: "plan:robill-smart:monthly",
    PLAN_ROBILL_SMART_QUARTERLY: "plan:robill-smart:quarterly",
    PLAN_ROBILL_SMART_YEARLY: "plan:robill-smart:yearly",
    ADDON_ROBILL_ETRANSPORT_MONTHLY: "addon:etransport:monthly",
    ADDON_ROBILL_ETRANSPORT_QUARTERLY: "addon:etransport:quarterly",
    ADDON_ROBILL_ETRANSPORT_YEARLY: "addon:etransport:yearly"
};
var PLANS_ARRAYS = {
    BASIC: [
        PLANS_MAP.PLAN_ROBILL_BASIC_MONTHLY,
        PLANS_MAP.PLAN_ROBILL_BASIC_QUARTERLY,
        PLANS_MAP.PLAN_ROBILL_BASIC_YEARLY
    ],
    SMART: [
        PLANS_MAP.PLAN_ROBILL_SMART_MONTHLY,
        PLANS_MAP.PLAN_ROBILL_SMART_QUARTERLY,
        PLANS_MAP.PLAN_ROBILL_SMART_YEARLY
    ],
    ETRANSPORT: [
        PLANS_MAP.ADDON_ROBILL_ETRANSPORT_MONTHLY,
        PLANS_MAP.ADDON_ROBILL_ETRANSPORT_QUARTERLY,
        PLANS_MAP.ADDON_ROBILL_ETRANSPORT_YEARLY
    ]
};
function getOneActiveSubscriptionForCompany(state) {
    //? Api should give us only active subscriptions //TODO -> maybe check expired if is in the past here?
    return function(planIdsArray, myCompanyId) {
        var allCompanySubscriptions = getAllSubscriptionsForCompany({
            state: state,
            myCompanyId: myCompanyId
        });
        if (!allCompanySubscriptions || allCompanySubscriptions.length === 0) {
            return null;
        }
        // Check if planIdsArray is an array of strings or a single string
        if (Array.isArray(planIdsArray)) {
            // Return the first match for any of the provided planIdsArray plan id
            return allCompanySubscriptions.find(function(sub) {
                return planIdsArray.includes(sub.planId);
            }) || null;
        } else if (typeof planIdsArray === "string") {
            // Return the first match for the single string planIdsArray plan id
            return allCompanySubscriptions.find(function(sub) {
                return sub.planId === planIdsArray;
            }) || null;
        }
        return null;
    };
}
function getPlansForTypeOfSubscription(state) {
    return function(planCodesArray) {
        var allCompanySubscriptions = state.auth.plans;
        if (!allCompanySubscriptions || allCompanySubscriptions.length === 0) {
            return [];
        }
        // Check if planCodesArray is an array of strings or a single string
        if (Array.isArray(planCodesArray)) {
            // Return all matches for the provided planCodesArray plan codes
            return allCompanySubscriptions.filter(function(sub) {
                return planCodesArray.includes(sub.code);
            });
        } else if (typeof planCodesArray === "string") {
            // Return all matches for the single string planCodesArray plan code
            return allCompanySubscriptions.filter(function(sub) {
                return sub.code === planCodesArray;
            });
        }
        return [];
    };
}
/*******************
 * REDUCER
 *******************/ export default createReducer({
    identity: null
}, function(builder) {
    builder.addCase(actionTypes.STORE_IDENTITY, function(state, action) {
        return _object_spread_props(_object_spread({}, state), {
            identity: action.payload
        });
    });
    builder.addCase(actionTypes.UPDATE_EMAIL, function(state, action) {
        return _object_spread_props(_object_spread({}, state), {
            identity: _object_spread_props(_object_spread({}, state.identity), {
                email: action.payload,
                emailVerifiedAt: Date.now()
            })
        });
    });
    builder.addCase(actionTypes.SYNC_IDENTITY_WITH_API, function(state, action) {
        var updatedIdentity = _object_spread({}, state.identity);
        Object.keys(action.payload).forEach(function(key) {
            if (Object.prototype.hasOwnProperty.call(updatedIdentity, key)) {
                updatedIdentity[key] = action.payload[key];
            }
        });
        return _object_spread_props(_object_spread({}, state), {
            identity: updatedIdentity
        });
    });
    builder.addCase(actionTypes.SHOW_WELCOME_MODAL, function(state, action) {
        return _object_spread_props(_object_spread({}, state), {
            showWelcomeModal: action.payload
        });
    });
    builder.addCase(actionTypes.STORE_PERMISSIONS, function(state, action) {
        return _object_spread_props(_object_spread({}, state), {
            permissions: action.payload
        });
    });
    builder.addCase(actionTypes.STORE_SUBSCRIPTIONS, function(state, action) {
        return _object_spread_props(_object_spread({}, state), {
            subscriptions: action.payload
        });
    });
    builder.addCase(actionTypes.STORE_PLANS, function(state, action) {
        return _object_spread_props(_object_spread({}, state), {
            plans: action.payload
        });
    });
    builder.addCase(actionTypes.CLEAR_IDENTITY, function() {
        return {
            identity: null,
            permissions: null,
            subscriptions: null,
            plans: null
        };
    });
});
/*******************
 * ACTIONS
 *******************/ export var authActions = {
    getCsrfToken: function getCsrfToken(abortControllerSignal) {
        return callPublicApiAction("GET", "/v1/auth/csrf-cookie", null, {
            signal: abortControllerSignal
        });
    },
    syncIdentityWithApi: function syncIdentityWithApi() {
        var propertiesToUpdate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return function(dispatch) {
            dispatch({
                type: actionTypes.SYNC_IDENTITY_WITH_API,
                payload: propertiesToUpdate
            });
        };
    },
    showWelcomeModal: function showWelcomeModal(type) {
        //used to let the dashboard render the welcome modal after creating the first company OR after verifying the email
        return function(dispatch) {
            dispatch({
                type: actionTypes.SHOW_WELCOME_MODAL,
                payload: type
            });
        };
    },
    loginApi: function loginApi(param, abortControllerSignal) {
        var email = param.email, password = param.password, rememberMe = param.rememberMe;
        return callPublicApiAction("POST", "/v1/auth/login", {
            email: email,
            password: password,
            rememberMe: rememberMe
        }, {
            signal: abortControllerSignal
        });
    },
    loginTwoFactorAuthApi: function loginTwoFactorAuthApi(data, abortControllerSignal) {
        return callPublicApiAction("POST", "/v1/auth/login/2fa", data, {
            signal: abortControllerSignal
        });
    },
    signupApi: function signupApi(param, abortControllerSignal) {
        var email = param.email, password = param.password, confirmPassword = param.confirmPassword, fname = param.fname, lname = param.lname, locale = param.locale, tos = param.tos, marketingOptIn = param.marketingOptIn, signupCompanyBusinessId = param.signupCompanyBusinessId, signupCompanyLegalName = param.signupCompanyLegalName;
        return callPublicApiAction("POST", "/v1/auth/signup", {
            email: email,
            password: password,
            confirmPassword: confirmPassword,
            fname: fname,
            lname: lname,
            locale: locale,
            tos: tos,
            marketingOptIn: marketingOptIn,
            signupCompanyBusinessId: signupCompanyBusinessId,
            signupCompanyLegalName: signupCompanyLegalName
        }, {
            signal: abortControllerSignal
        });
    },
    /**
     * Used by the login & signup flows but also partially by the getIdentify flow
     */ storeIdentity: function storeIdentity(identity) {
        return function(dispatch, getState) {
            var crispWebsiteId = configSelectors.crispWebsiteId(getState());
            dispatch({
                type: actionTypes.STORE_IDENTITY,
                payload: identity
            });
            setUser({
                id: identity.id
            });
            if (posthog.has_opted_in_capturing()) {
                posthog.identify(identity.id);
            }
            setLocalStorageItem("locale", identity.preferredLocale);
            if (crispWebsiteId) {
                Crisp.session.setData({
                    userId: identity.id
                });
                Crisp.user.setEmail(identity.email);
                Crisp.user.setNickname("".concat(identity.fname, " ").concat(identity.lname));
            }
        };
    },
    getIdentityApi: function getIdentityApi(myCompanyIdFromQuery) {
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch, getState) {
                var body, crispWebsiteId;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                dispatch(callPrivateApiAction("GET", "/v1/auth/identity"))
                            ];
                        case 1:
                            body = _state.sent().body;
                            if (!body.emailVerifiedAt) return [
                                3,
                                3
                            ];
                            /**
                 * We need to get the companies pairs here, and not in AuthManager,
                 * otherwise login will run before we have the companies list
                 */ return [
                                4,
                                dispatch(myCompaniesActions.getMyCompaniesPairs(null, myCompanyIdFromQuery))
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            dispatch({
                                type: actionTypes.STORE_IDENTITY,
                                payload: body
                            });
                            setUser({
                                id: body.id
                            });
                            if (posthog.has_opted_in_capturing()) {
                                posthog.identify(body.id);
                            }
                            crispWebsiteId = configSelectors.crispWebsiteId(getState());
                            if (crispWebsiteId) {
                                Crisp.session.setData({
                                    userId: body.id
                                });
                                Crisp.user.setEmail(body.email);
                                Crisp.user.setNickname("".concat(body.fname, " ").concat(body.lname));
                            }
                            return [
                                2,
                                body
                            ];
                    }
                });
            });
            return function(dispatch, getState) {
                return _ref.apply(this, arguments);
            };
        }();
    },
    logoutApi: function logoutApi() {
        var _this = this;
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch, getState) {
                var crispWebsiteId, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                dispatch(callPrivateApiAction("POST", "/v1/auth/logout"))
                            ];
                        case 1:
                            _state.sent();
                            dispatch(_this.clearIdentity());
                            crispWebsiteId = configSelectors.crispWebsiteId(getState());
                            if (crispWebsiteId && Crisp.isCrispInjected()) {
                                try {
                                    Crisp.session.reset(false);
                                } catch (e) {
                                    console.error("crisp reset failed");
                                }
                            }
                            return [
                                2,
                                true
                            ];
                        case 2:
                            error = _state.sent();
                            if (error.response && error.response.status === 401) {
                                //? To avoid having 2 flashMessages here, will keep only the "session expired" one, without the "common.logout.could-not-logout" one
                                return [
                                    2,
                                    true
                                ];
                            }
                            handleReportError(error);
                            return [
                                2,
                                false
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(dispatch, getState) {
                return _ref.apply(this, arguments);
            };
        }();
    },
    clearIdentity: function clearIdentity() {
        return function(dispatch) {
            dispatch({
                type: actionTypes.CLEAR_IDENTITY
            });
            dispatch(myCompaniesActions.resetPairsAndSelectedCompany());
            setUser(null);
            posthog.reset(false); //posthog.set_config({   bootstrap: { distinctID: Math.floor(Math.random() * 100000) + 1 }, });
            dispatch(listFactoryActions.resetCurrentListingState());
        };
    },
    updateEmail: function updateEmail(email) {
        return {
            type: actionTypes.UPDATE_EMAIL,
            payload: email
        };
    },
    startForgotPasswordApi: function startForgotPasswordApi(email, abortControllerSignal) {
        return callPublicApiAction("POST", "/v1/auth/reset-password/start", {
            email: email
        }, {
            signal: abortControllerSignal
        });
    },
    finishForgotPasswordApi: function finishForgotPasswordApi(param, abortControllerSignal) {
        var email = param.email, code = param.code, password = param.password, confirmPassword = param.confirmPassword;
        return callPublicApiAction("POST", "/v1/auth/reset-password/finish", {
            email: email,
            code: code,
            password: password,
            confirmPassword: confirmPassword
        }, {
            signal: abortControllerSignal
        });
    },
    resendVerifyEmailCode: function resendVerifyEmailCode(abortControllerSignal) {
        return callPrivateApiAction("POST", "/v1/auth/verify-email/resend", null, {
            signal: abortControllerSignal
        });
    },
    finishVerifyEmailApi: function finishVerifyEmailApi(code, abortControllerSignal) {
        return callPrivateApiAction("POST", "/v1/auth/verify-email/finish", {
            code: code
        }, {
            signal: abortControllerSignal
        });
    },
    updateMyAccountApi: function updateMyAccountApi(param, abortControllerSignal) {
        var fname = param.fname, lname = param.lname, timezone = param.timezone, locale = param.locale, marketingOptIn = param.marketingOptIn;
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch, getState) {
                var result, identity;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                dispatch(callPrivateApiAction("POST", "/v1/auth/update-account", {
                                    fname: fname,
                                    lname: lname,
                                    timezone: timezone,
                                    marketingOptIn: marketingOptIn,
                                    locale: locale
                                }, {
                                    signal: abortControllerSignal
                                }))
                            ];
                        case 1:
                            result = _state.sent();
                            identity = getIdentity(getState());
                            dispatch({
                                type: actionTypes.STORE_IDENTITY,
                                payload: _object_spread_props(_object_spread({}, identity), {
                                    fname: fname,
                                    lname: lname,
                                    timezone: timezone,
                                    locale: locale,
                                    marketingOptIn: marketingOptIn
                                })
                            });
                            return [
                                2,
                                result
                            ];
                    }
                });
            });
            return function(dispatch, getState) {
                return _ref.apply(this, arguments);
            };
        }();
    },
    startChangeEmailApi: function startChangeEmailApi(param, abortControllerSignal) {
        var password = param.password, email = param.email;
        return callPrivateApiAction("POST", "/v1/auth/change-email/start", {
            password: password,
            email: email
        }, {
            signal: abortControllerSignal
        });
    },
    startTwoFactorAuthentication: function startTwoFactorAuthentication(data, abortControllerSignal) {
        return callPrivateApiAction("POST", "/v1/auth/2fa/start", data, {
            signal: abortControllerSignal
        });
    },
    resendTwoFactorAuthenticationSmsCode: function resendTwoFactorAuthenticationSmsCode(data, abortControllerSignal) {
        return callPrivateApiAction("POST", "/v1/auth/2fa/resend-sms-code", data, {
            signal: abortControllerSignal
        });
    },
    loginResendTwoFactorAuthenticationSmsCode: function loginResendTwoFactorAuthenticationSmsCode(abortControllerSignal) {
        return callPrivateApiAction("POST", "/v1/auth/login/2fa/resend-sms-code", null, {
            signal: abortControllerSignal
        });
    },
    regenerateTwoFactorAuthenticationRecoveryCodes: function regenerateTwoFactorAuthenticationRecoveryCodes(data, abortControllerSignal) {
        return callPrivateApiAction("POST", "/v1/auth/2fa/recovery-codes", data, {
            signal: abortControllerSignal
        });
    },
    finishTwoFactorAuthentication: function finishTwoFactorAuthentication(param, abortControllerSignal) {
        var code = param.code, password = param.password;
        return callPrivateApiAction("POST", "/v1/auth/2fa/finish", {
            code: code,
            password: password
        }, {
            signal: abortControllerSignal
        });
    },
    deactivateTwoFactorAuthentication: function deactivateTwoFactorAuthentication(data, abortControllerSignal) {
        return callPrivateApiAction("DELETE", "/v1/auth/2fa", data, {
            signal: abortControllerSignal
        });
    },
    finishChangeEmailPinApi: function finishChangeEmailPinApi(code, abortControllerSignal) {
        return callPrivateApiAction("POST", "/v1/auth/change-email/finish", {
            code: code
        }, {
            signal: abortControllerSignal
        });
    },
    changePasswordApi: function changePasswordApi(param, abortControllerSignal) {
        var currentPassword = param.currentPassword, password = param.password, confirmPassword = param.confirmPassword;
        return callPrivateApiAction("POST", "/v1/auth/change-password", {
            currentPassword: currentPassword,
            password: password,
            confirmPassword: confirmPassword
        }, {
            signal: abortControllerSignal
        });
    },
    deleteAccount: function deleteAccount(param, abortControllerSignal) {
        var password = param.password;
        return callPrivateApiAction("delete", "/v1/auth/delete-account", {
            password: password
        }, {
            signal: abortControllerSignal
        });
    },
    loadTimezones: function loadTimezones(abortControllerSignal) {
        return function(dispatch) {
            return dispatch(callPrivateApiAction("GET", "/v1/auth/timezones", null, {
                signal: abortControllerSignal
            })).then(function(param) {
                var body = param.body;
                return Object.keys(body).map(function(item) {
                    return {
                        label: body[item],
                        value: item
                    };
                });
            });
        };
    },
    getPermissions: function getPermissions(abortControllerSignal) {
        return function(dispatch) {
            return dispatch(callPrivateApiAction("GET", "/v1/auth/permissions", null, {
                signal: abortControllerSignal
            })).then(function(param) {
                var body = param.body;
                dispatch({
                    type: actionTypes.STORE_PERMISSIONS,
                    payload: body
                });
                return body;
            });
        };
    },
    getSubscriptions: function getSubscriptions(abortControllerSignal) {
        return function(dispatch) {
            return dispatch(callPrivateApiAction("GET", "/v1/billing/subscriptions", null, {
                signal: abortControllerSignal
            })).then(function(param) {
                var body = param.body;
                dispatch({
                    type: actionTypes.STORE_SUBSCRIPTIONS,
                    payload: body
                });
                return body;
            });
        };
    },
    getPlans: function getPlans(abortControllerSignal) {
        //TODO next week -> ia iar plans dupa ce se schimba limba sa nu ramana in urma pana la reload page
        return function(dispatch) {
            return dispatch(callPrivateApiAction("GET", "/v1/billing/plans", null, {
                signal: abortControllerSignal
            })).then(function(param) {
                var body = param.body;
                dispatch({
                    type: actionTypes.STORE_PLANS,
                    payload: body
                });
                return body;
            });
        };
    },
    activateRobillSmart: function activateRobillSmart(myCompanyId, abortControllerSignal) {
        return callPrivateApiAction("post", "/v1/my-companies/".concat(myCompanyId, "/billing/subscribe-robill-smart"), null, {
            signal: abortControllerSignal
        });
    }
};
/*******************
 * SELECTORS
 *******************/ var getIdentity = memoize(function(state) {
    return state.auth.identity;
});
var hasIdentity = memoize(function(state) {
    return !!getIdentity(state);
});
var getETransportPlans = memoize(function(state) {
    return getPlansForTypeOfSubscription(state)(PLANS_ARRAYS.ETRANSPORT);
});
var getSmartPlans = memoize(function(state) {
    return getPlansForTypeOfSubscription(state)(PLANS_ARRAYS.SMART);
});
var getBasicPlans = memoize(function(state) {
    return getPlansForTypeOfSubscription(state)(PLANS_ARRAYS.BASIC);
});
var getETransportPlansIds = memoize(function(state) {
    return getETransportPlans(state).map(function(plan) {
        return plan.id;
    });
});
var getSmartPlansIds = memoize(function(state) {
    return getSmartPlans(state).map(function(plan) {
        return plan.id;
    });
});
var getBasicPlansIds = memoize(function(state) {
    return getBasicPlans(state).map(function(plan) {
        return plan.id;
    });
});
var getFeatureFlags = memoize(function(state) {
    var _state_auth_identity;
    return (_state_auth_identity = state.auth.identity) === null || _state_auth_identity === void 0 ? void 0 : _state_auth_identity.featureFlags;
});
var fname = memoize(function(state) {
    return getIdentity(state).fname;
});
var lname = memoize(function(state) {
    return getIdentity(state).lname;
});
export var authSelectors = {
    getIdentity: getIdentity,
    hasIdentity: hasIdentity,
    fname: fname,
    lname: lname,
    signupCompanyBusinessId: memoize(function(state) {
        return getIdentity(state).signupCompanyBusinessId;
    }),
    signupCompanyLegalName: memoize(function(state) {
        return getIdentity(state).signupCompanyLegalName;
    }),
    isTwoFaEnabled: memoize(function(state) {
        return !!getIdentity(state).twoFactorType;
    }),
    tenantId: memoize(function(state) {
        return hasIdentity(state) ? getIdentity(state).tenantId : null;
    }),
    userId: memoize(function(state) {
        return hasIdentity(state) ? getIdentity(state).id : null;
    }),
    email: memoize(function(state) {
        var _getIdentity;
        return (_getIdentity = getIdentity(state)) === null || _getIdentity === void 0 ? void 0 : _getIdentity.email;
    }),
    emailIsVerified: memoize(function(state) {
        var _getIdentity;
        return (_getIdentity = getIdentity(state)) === null || _getIdentity === void 0 ? void 0 : _getIdentity.emailVerifiedAt;
    }),
    timezone: memoize(function(state) {
        return getIdentity(state).timezone;
    }),
    marketingOptIn: memoize(function(state) {
        return getIdentity(state).marketingOptIn;
    }),
    dateFormat: memoize(function(state) {
        return getIdentity(state).dateFormat;
    }),
    preferredLocale: memoize(function(state) {
        return getIdentity(state).locale;
    }),
    showWelcomeModal: memoize(function(state) {
        return handleWelcomeModalByFeatureFlag(getFeatureFlags(state));
    }),
    isAdmin: memoize(function(state) {
        var _state_auth_permissions;
        return (_state_auth_permissions = state.auth.permissions) === null || _state_auth_permissions === void 0 ? void 0 : _state_auth_permissions.global.roles.includes(USERS_ROLES.ADMIN);
    }),
    permissions: memoize(function(state) {
        return getPermissionsForCompany(state);
    }),
    hasPermission: memoize(function(state) {
        return function(permission) {
            return authSelectors.permissions(state).includes(permission);
        };
    }),
    companyPermissions: function(myCompanyId) {
        return function(state) {
            return getPermissionsForCompany(state, myCompanyId);
        };
    },
    companyHasPermission: memoize(function(state) {
        return function(myCompanyId, permission) {
            return authSelectors.companyPermissions(myCompanyId)(state).includes(permission);
        };
    }),
    getPlans: memoize(function(state) {
        return state.auth.plans;
    }),
    getETransportPlans: getETransportPlans,
    getSmartPlans: getSmartPlans,
    getBasicPlans: getBasicPlans,
    getETransportPlansIds: getETransportPlansIds,
    getSmartPlansIds: getSmartPlansIds,
    getBasicPlansIds: getBasicPlansIds,
    // subscriptions: memoize((state) => getAllSubscriptionsForCompany(state)),
    getETransportSubscription: function(myCompanyId) {
        return function(state) {
            return getOneActiveSubscriptionForCompany(state)(getETransportPlansIds(state), myCompanyId);
        };
    },
    getSmartSubscription: function(myCompanyId) {
        return function(state) {
            return getOneActiveSubscriptionForCompany(state)(getSmartPlansIds(state), myCompanyId);
        };
    },
    getBasicSubscription: function(myCompanyId) {
        return function(state) {
            return getOneActiveSubscriptionForCompany(state)(getBasicPlansIds(state), myCompanyId);
        };
    }
};
